export const queryKeys = {
	consigneeIds: ["consigneeIds"] as const
};